import ImageCrop from 'react-image-crop';
import 'react-image-crop/dist/ReactCrop.css';

export default ImageCrop;
